var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"doughnut-footer"},_vm._l((_vm.data.labels),function(label,index){return _c('doughnut-chart-footer-item',{key:index,attrs:{"label":label,"value":_vm.datasetItemValue(index),"total":_vm.total,"index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }